import React from 'react';
import './About.css';
import OptimizedImage from '../OptimizedImage/OptimizedImage';

const About: React.FC = () => {
  return (
    <section id="about" className="about-wrapper">
        {/* <div className="aw-introduction">
        <div className="i-description">
          <div className="title">
            <h1>About</h1>
            <h2 id="gold">BlueLake</h2>
          </div>
          <p>
            We are a <span id="gold">premier</span> architectural firm dedicated to creating 
            innovative, <span id="gold">sustainable</span>, and <span id="gold">beautiful</span> spaces. Our team 
            combines <span id="gold">creative vision</span> with technical expertise to deliver exceptional 
            architectural solutions that exceed our clients' expectations.
          </p>
        </div>
        <div className="i-banner">
          <OptimizedImage
            src="/assets/images/bluelake_office/bluelake_office_1.png"
            alt="BlueLake Studio"
          />
        </div>
      </div> */}
      
      <div className="about-container">
        <div className="about-banner-container">
          <OptimizedImage
            src="/assets/images/bluelake_office/bluelake_office_2.png"
            alt="Our Work"
          />
        </div>
        <div className="about-desc-container">
          <div className="title">
            <h1>Our</h1>
            <h2 id="gold">Philosophy</h2>
          </div>
          <p>
            Every project starts with one goal: to bring your <span id="gold">vision</span> to life.
            <br></br>
            We are more than a design & build company, we are your <span id="gold">creative partner</span>.
            <br></br>
            Our team listens closely, plans with precision, and delivers projects that reflect your vision
            while maintaining quality and budget integrity.
          </p>
          {/* <p>
            Every project is an opportunity to create something <span id="gold">extraordinary</span>. 
            We believe that great architecture should not only be <span id="gold">visually stunning</span> but also 
            functional, sustainable, and deeply connected to its <span id="gold">environment</span>.
          </p> */}
        </div>
      </div>
      
      <div className="team-container">
        <div className="team-description">
          <div className="title">
            <h1>Our</h1>
            <h2 id="gold">Expert Team</h2>
          </div>
          {/* <p>
            Our dedicated core team is committed to delivering <span id="gold">exceptional</span> results from concept to completion.
            With expertise across various aspects of design and build, each team member contributes
            specialized skills, creativity, and meticulous attention to detail. 
            <br></br>
            Together, we ensure seamless
            collaboration, efficient project execution, and a client-focused approach that turns visions into reality.
          </p> */}
          <p>
            Our diverse team of architects, designers, and engineers brings together 
            decades of experience and a shared passion for creating <span id="gold">exceptional spaces </span> 
            that inspire and endure.
          </p>
        </div>
        <div className="team-image">
          <div className="team-image-grid">
            <div className="team-image-details">
              <OptimizedImage
                src="/assets/images/bluelake_office/bluelake_ceo.png"
                alt="CEO"
              />
              <div className="team-image-details-name">
                <h3>Andreas Kurnia</h3>
                <p>CEO and Founder</p>
              </div>
            </div>
            <div className="team-image-details">
              <OptimizedImage
                src="/assets/images/bluelake_office/bluelake_cofounder.png"
                alt="CoFounder"
              />
              <div className="team-image-details-name">
                <h3>Agnes Kurnia</h3>
                <p>Co-Founder</p>
              </div>
            </div>
          </div>
        </div>
        </div>
    </section>
  );
};

export default About;